import React from 'react';
import Modal from 'react-modal';

import { api } from '../../../services/api';

import { AiOutlineClose } from "react-icons/ai";

function DeleteTemplateModal ({isOpen, onRequestClose, template}){
    async function deleteTemplate(){
        try {
            await api.delete(`/templatec/${template.id_template_c}`);
            onRequestClose(true, true);
        } catch (error) {
            let msg_error = undefined;
            
            if (error && error.response && error.response.data) {
                const errorData = error.response.data;
                if (typeof errorData.error === 'string') {
                  msg_error = errorData.error;
                }
            }

            onRequestClose(true, false, msg_error);
        }
    }

    return (
        <Modal
            ariaHideApp={false}
            overlayClassName="react-modal-overlay"
            className="react-modal-content react-modal-content-delete"
            isOpen={isOpen} 
            onRequestClose={onRequestClose}
        >
            <button 
                className="react-modal-close"
                onClick={onRequestClose} 
            >
                <AiOutlineClose />
            </button>
            <div className="react-modal-title">
                <h4 id="modal-title">Excluir Template</h4>
            </div>

            <div className="react-modal-body">
            <span className="modal-text">
                    Tem certeza que deseja excluir o template {template.name_template}?
                </span>
                <div className="react-modal-btn">
                    <button className="btn btn-blue" onClick={onRequestClose} >
                        Cancelar
                    </button>
                    <button className="btn btn-red" onClick={deleteTemplate}>
                        Excluir
                    </button>
                </div>
            </div>
        </Modal>

    );
}

export default DeleteTemplateModal;